/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../Fixes';
import Builder from '../../Builder';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "common": {
        "nested": {
          "identitykeys": {
            "nested": {
              "IdentityKeys": {
                "fields": {
                  "capitalCustomer": {
                    "type": ".squareup.common.identitykeys.CapitalCustomer",
                    "id": 1
                  },
                  "buyerProfile": {
                    "type": ".squareup.common.identitykeys.BuyerProfile",
                    "id": 2
                  }
                },
                "nested": {
                  "type": {
                    "oneof": ["capitalCustomer", "buyerProfile"]
                  }
                }
              },
              "CapitalCustomer": {
                "fields": {
                  "token": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              },
              "BuyerProfile": {
                "fields": {
                  "status": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.common?.nested?.identitykeys?.nested?.IdentityKeys && !$root.nested?.squareup?.nested?.common?.nested?.identitykeys?.nested?.CapitalCustomer && !$root.nested?.squareup?.nested?.common?.nested?.identitykeys?.nested?.BuyerProfile) {
  $root.addJSON(jsonData);
}

/**
 * Represents additional identity information stored on a Person for each
 * scope, and propagated into the multipass session.  The resulting proto must
 * encode to no more than MAX_IDENTITY_KEY_BYTES bytes.
 *
 * SOURCE IdentityKeys @ squareup/common/identity_keys.proto at 11:1
 */
export const IdentityKeys = $root.lookupType('squareup.common.identitykeys.IdentityKeys');
fixType(IdentityKeys);
Builder.createAndAttachToType(IdentityKeys);
/**
 * SOURCE CapitalCustomer @ squareup/common/identity_keys.proto at 23:1
 */
export const CapitalCustomer = $root.lookupType('squareup.common.identitykeys.CapitalCustomer');
fixType(CapitalCustomer);
Builder.createAndAttachToType(CapitalCustomer);
/**
 * Used by Buyer Profile Service to store additional/generic profile
 * metadata in Person Service.
 *
 * SOURCE BuyerProfile @ squareup/common/identity_keys.proto at 31:1
 */
export const BuyerProfile = $root.lookupType('squareup.common.identitykeys.BuyerProfile');
fixType(BuyerProfile);
Builder.createAndAttachToType(BuyerProfile);